import { render, staticRenderFns } from "./FloatIcon.vue?vue&type=template&id=5b5f5fc0&scoped=true"
import script from "./FloatIcon.vue?vue&type=script&lang=js"
export * from "./FloatIcon.vue?vue&type=script&lang=js"
import style0 from "./FloatIcon.vue?vue&type=style&index=0&id=5b5f5fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f5fc0",
  null
  
)

export default component.exports